<template>
  <div>

    <el-table
      :data="tableData"
      border
      style="width: 100%; margin-top: 20px"
    >
      <el-table-column
        prop="userPhone"
        label="用户手机号"
        width="220"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="userAccount"
        label="用户账号"
        width="220"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="serverIp"
        label="服务器ip"
        align="center"
        width="320"
      ></el-table-column>
      <el-table-column
        prop="status"
        label="用户状态"
        align="center"
        width="140"
      >
        <template slot-scope="scope">
          <span>{{scope.row.status == 1 ? '启用' : '禁用'}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="isDelete"
        label="是否删除"
        align="center"
        width="140"
      >
        <template slot-scope="scope">
          <span>{{scope.row.status == 1 ? '是' : '否'}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="addTime"
        label="更新时间"
        align="center"
      ></el-table-column>
    </el-table>
    <div
      class="tc"
      style="margin-top: 20px"
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { Api_login } from "@/api/api";
export default {
  components: {
  },
  mixins: [],
  data() {
    return {
      totalCount: 0,
      currentPage: 1,
      pagesize: 10,
      tableData: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let params = {
        "serverIp": "",
        "phone": "",
        "status": 0,
        "isDelete": 0,
        "pageSize": this.pagesize,
        "pageIndex": this.currentPage,
      }
      console.log(Api_login, 'Api_login')
      Api_login.appUserList(params).then((res) => {
        this.tableData = res.data.data.tList;
        this.totalCount = res.data.data.totalCount;
      });
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.pushInformation {
  width: 100px;
  height: 30px;
  padding: 0 10px;
  background-color: #169bd5;
  cursor: pointer;
  border: none;
  border-radius: 3px;
  color: #fff;
  /deep/ .el-tooltip__popper {
    width: 200px;
  }
}
</style>
<style>
.groupLists .el-checkbox {
  width: 20%;
  margin-right: 4%;
}
</style>